import { createFileRoute } from '@tanstack/react-router';

import { deleteAuthorizationScreen, loadDataprevEmployeeMessages, loadDataprevEmployeeScreens, testToolSearch } from '@/modules/dataprev-employee/route';
import { lazyScreen } from '@/shared/screen';

// Excluir Autorização de Margem no caminho do legado (`router.tsx:1328-1336`), só com
// ENABLE_DATAPREV_TEST === 1. Arquivo leve (JS inicial).
export const Route = createFileRoute('/_app/ccb/excluir-autorizacao/')({
  validateSearch: testToolSearch,
  staticData: { screen: deleteAuthorizationScreen },
  loader: () => loadDataprevEmployeeMessages(),
  component: lazyScreen(loadDataprevEmployeeScreens, 'DeleteAuthorizationRouteScreen'),
});
